import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { connect } from 'react-redux'
import { getAvailableIconList } from '../../store/actions/icons'

class IconSelector extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            iconNames: [],
            options: undefined,
        }
    }

    componentDidMount() {
        this.props.getAvailableIconList()
    }

    componentDidUpdate(prevProps) {
        if (this.props.icons !== prevProps.icons) {
            const iconNames = this.props.icons.map((ic) => ic.name)

            this.setState({
                iconNames: iconNames,
                options: iconNames.map((ic) => ({
                    value: ic,
                    label: (
                        <h3 className="text-secondary">
                            <FontAwesomeIcon icon={ic} />
                        </h3>
                    ),
                    selected:
                        this.props.selectedIcon &&
                        this.props.selectedIcon === ic,
                })),
            })
        }
    }

    onSelectionChange = (selection) => {
        this.props.onSelectionChange(selection)
    }

    onClick = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                const renderIconGrid = () => {
                    var numRows = Math.ceil(this.state.iconNames.length / 4)
                    var rows = []

                    for (let r = 0; r < numRows; r++) {
                        rows.push(this.state.iconNames.slice(r * 4, r * 4 + 4))
                    }

                    return rows.map((r) => (
                        <div className="row">
                            {r.map((icName) => (
                                <button
                                    className="icon-select-button btn btn-white"
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        border: 'solid 1px #ced4da',
                                    }}
                                    onClick={() => {
                                        this.props.onSelectionChange(icName)
                                        onClose()
                                    }}>
                                    <h1 className="text-secondary text-center mb-0 ">
                                        <FontAwesomeIcon icon={icName} />
                                    </h1>
                                </button>
                            ))}
                        </div>
                    ))
                }

                return (
                    <div className="border p-4" style={{ width: '400px' }}>
                        <h4 className="text-primary mb-4">Select your icon!</h4>
                        {!this.props.icons || this.props.icons.length === 0 ? (
                            <p>No icons available...</p>
                        ) : (
                            <div className="">{renderIconGrid()}</div>
                        )}
                    </div>
                )
            },
        })
    }

    render() {
        return (
            <button
                className="icon-select-button btn btn-white"
                style={{
                    width: '80px',
                    height: '80px',
                    border: 'solid 1px #ced4da',
                }}
                onClick={this.state.options ? this.onClick : null}>
                <h1 className="text-secondary text-center mb-0 ">
                    <FontAwesomeIcon
                        icon={this.props.selectedIcon || 'lightbulb'}
                    />
                </h1>
            </button>
        )
    }
}

const mapStateToProps = (state) => ({
    icons: state.icons.availableIconsList,
})

export default connect(mapStateToProps, { getAvailableIconList })(IconSelector)
